// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"nav-undo-redo-options-module__skeletonContainer--aqRkZ"};